module.exports = __webpack_public_path__ + "img/2.57fbe8c2.png";